export const formatIban = (iban: string) => {
  const countryCode = iban.substring(0, 2);
  const controlNumbers = iban.substring(2, 4);
  const bankMFO = iban.substring(4, 10);
  const zeros = iban.substring(10, 15);
  const accountNumber = iban.substring(15);

  return `${countryCode} ${controlNumbers} ${bankMFO} ${zeros} ${accountNumber}`;
};
